import { render, staticRenderFns } from "./welfare.vue?vue&type=template&id=f41d653c&scoped=true"
import script from "./welfare.vue?vue&type=script&lang=js"
export * from "./welfare.vue?vue&type=script&lang=js"
import style0 from "./welfare.vue?vue&type=style&index=0&id=f41d653c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41d653c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-hmt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f41d653c')) {
      api.createRecord('f41d653c', component.options)
    } else {
      api.reload('f41d653c', component.options)
    }
    module.hot.accept("./welfare.vue?vue&type=template&id=f41d653c&scoped=true", function () {
      api.rerender('f41d653c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/welfare.vue"
export default component.exports